export interface IAloDataRawHeaderConstParam {
    pos:number
    dbName:string
    dbTypeName:string
}

export class AloDataRawHeader {
    
    public pos:number
    public dbName:string
    public dbTypeName:string

    constructor({pos,dbName,dbTypeName}:IAloDataRawHeaderConstParam = {} as IAloDataRawHeaderConstParam) {
        this.pos = pos
        this.dbName = dbName        
        this.dbTypeName = dbTypeName
    }
}